import { useAuth } from "react-oidc-context";
import "./App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import BranchHome from "./Pages/BranchHome";
import AdminHome from "./Pages/AdminHome";
import BranchManagement from "./Pages/BranchManagement";
import AdminThirdPartyLedger from "./Pages/AdminThirdPartyLedger";
import WaitingPayments from "./Pages/WaitingPayments";
import CommissionAudit from "./Pages/CommissionAudit";
import BankersTransaction from "./Pages/bankersTransaction";
import BankersManagement from "./Pages/BankersManagement";
import BankerLedger from "./Pages/BankerLedger";
import BTBBankerMatching from "./Pages/BTBBankerMatching";
import AdminBalanceManager from "./Pages/AdminBalanceManager";
import AdminControl from "./Pages/AdminControl";
import AdminMessageMonitor from "./Pages/AdminMessageMonitor";
import CommissionCheck from "./Pages/CommissionCheck";
import ThirdPartyManagement from "./Pages/ThirdPartyManagement";
import AdminStatement from "./Pages/AdminStatement";
import SelfTransactionManager from "./Pages/SelfTransactionManager";
import AdminVideoManager from "./Pages/AdminVideoManager";
import VideoPlayerPage from "./Pages/VideoPlayerPage"
import AdminEntry from "./Pages/AdminEntry";
import AdminDateEditor from "./Pages/AdminDateEditor";
import AdminAuditReport from "./Pages/AdminAuditReport";
import BranchRejected from "./Pages/BranchRejected";
import AdminCleanup from "./Pages/AdminCleanup";
import TransactionAuditor from "./Pages/TransactionAuditor";
function App() {
  const auth = useAuth();
  const userGroups = auth.user?.profile?.["cognito:groups"] ?? [];
  // SignOut
  const handleSignOut = () => {
    const clientId = process.env.REACT_APP_CLIENT_ID; // Get this from your .env
    const logoutUri = window.location.origin + "/";
    const cognitoDomain =
      "https://ap-south-1568k9cbda.auth.ap-south-1.amazoncognito.com";

    // 1. Clear local data first
    auth.removeUser();

    // 2. Redirect to Cognito's logout endpoint
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };
  // Define our group checks
  const isInBranchGroup = userGroups.includes("Branch");
  const isInBankersGroup = userGroups.includes("Bankers");
  const isInAdminGroup = userGroups.includes("Admin"); // Assuming your admin group is named "Admin"

  // Redirect Logic for Branch and Bankers
  if (auth.isAuthenticated && isInBranchGroup) {
    try {
      window.history.replaceState(null, "", "/Branch");
    } catch (e) {
      window.location.href = "/Branch";
    }
  }

  if (auth.isAuthenticated && isInBankersGroup) {
    try {
      window.history.replaceState(null, "", "/Bankers");
    } catch (e) {
      window.location.href = "/Bankers";
    }
  }

  if (auth.isLoading) {
    return <div className="loading-screen">Loading...</div>;
  }
  // Inside your main App or Dashboard component

  if (auth.error) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h2 className="title">Network Problem</h2>
          <p>Sign in again</p>
          <div className="button-group">
            <button
              className="btn signin"
              onClick={() => {
                auth.removeUser();
                auth.signinRedirect();
              }}
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    );
  }

  // --- NEW BLOCK: NO GROUP WARNING ---
  // If user is logged in but NOT in Admin, Branch, or Bankers
  if (
    auth.isAuthenticated &&
    !isInAdminGroup &&
    !isInBranchGroup &&
    !isInBankersGroup
  ) {
    return (
      <div className="login-container">
        <div className="login-box" style={{ borderColor: "#ff4d4d" }}>
          <h2 className="title" style={{ color: "#d32f2f" }}>
            Access Denied
          </h2>
          <p style={{ marginBottom: "20px" }}>
            Your account (<b>{auth.user?.profile?.email}</b>) is not assigned to
            any user group.
          </p>
          <p>Please contact the Admin to be added to a group.</p>
          <div className="button-group">
            <button className="btn signout" onClick={handleSignOut}>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Authorized Views
  if (auth.isAuthenticated) {
    return (
      <BrowserRouter>
        <Routes>
          {/* Admin Routes - Only accessible if in Admin Group */}
          {isInAdminGroup ? (
            <>
              <Route path="/" element={<AdminHome />} />
              <Route path="bm" element={<BranchManagement />} />
              <Route path="brm" element={<BankersManagement />} />
              <Route path="/bankers-ledger" element={<BankerLedger />} />
              <Route path="/admin-balance" element={<AdminBalanceManager />} />
              <Route path="/admin-control" element={<AdminControl />} />
              <Route
                path="/admin-message-monitor"
                element={<AdminMessageMonitor />}
              />
              <Route path="/commission-check" element={<CommissionCheck />} />
              <Route
                path="/third-party-management"
                element={<ThirdPartyManagement />}
              />
              <Route path="/admin-statement" element={<AdminStatement />} />

              <Route
                path="/admin-self-manage"
                element={<SelfTransactionManager />}
              />
              <Route
                path="/btb-banker-matching"
                element={<BTBBankerMatching />}
              />
              <Route path="/admin-cleanup" element={<AdminCleanup />} />
              <Route path="/admin/video-control" element={<AdminVideoManager />} />
              <Route path="/admin-entry" element={<AdminEntry />} />
              <Route path="/third-party" element={<AdminThirdPartyLedger />} />
              <Route path="/waiting" element={<WaitingPayments />} />
              <Route path="/commission-audit" element={<CommissionAudit />} />
              <Route path="/admin-date-editor" element={<AdminDateEditor />} />
              <Route path="/admin-audit-report" element={<AdminAuditReport />} />
              <Route path="/admin-error-check" element={<TransactionAuditor />} />
            </>
          ) : (
            // If not admin, redirect any attempt to hit "/" to their respective homes
            <Route
              path="/"
              element={
                isInBranchGroup ? <BranchHome /> : <BankersTransaction />
              }
            />
          )}

          {/* Specific Routes */}
          <Route path="/Branch" element={<BranchHome />} />
          <Route path="/training-video" element={<VideoPlayerPage />} />
          <Route path="/Bankers" element={<BankersTransaction />} />
          <Route path="/BranchRejected" element={<BranchRejected auth={auth} />} />
          <Route
            path="*"
            element={
              <div style={{ textAlign: "center", padding: "50px" }}>
                <h2>404 Not Found</h2>
                <Link to="/">
                  <button className="btn">Go Home</button>
                </Link>
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    );
  }

  // Login Screen for unauthenticated users
  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="title">Welcome V-C</h1>
        <p className="subtitle">Sign in to continue</p>
        <div className="button-group">
          <button className="btn signin" onClick={() => auth.signinRedirect()}>
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
